// extracted by mini-css-extract-plugin
export default {"icon":"VariablesPayrollTable_icon__xnmkP"};